import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import MenuStore from '../../stores/MenuStore';
import FuseButton from './FuseButton';
import { Key } from '../../mirror/userInput';
import Dropdown from '../Dropdown';
import './FuseMenu.css';

const block = b.lock('FuseMenu');

export default class FuseMenu extends Component {
    static propTypes = {
        open: PropTypes.bool,
        className: PropTypes.string,
        itemClassName: PropTypes.string,
        iconClassName: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.string,
            disabled: PropTypes.bool,
            onClick: PropTypes.func.isRequired,
            qa: PropTypes.string,
        })).isRequired,
        toggle: PropTypes.func,
    };

    state = {
        position: 'bottom',
        hovered: null,
    };

    componentDidMount() {
        if (this.element) {
            this.element.addEventListener('keydown', this.handleKeyDown);
        }
    }

    componentWillUnmount() {
        if (this.element) {
            this.element.removeEventListener('keydown', this.handleKeyDown);
        }
    }

    getScrollableParent = (node) => {
        if (node == null) {
            return null;
        }

        const computedStyle = window.getComputedStyle(node);
        if (computedStyle.overflowX === 'auto' || computedStyle.overflowX === 'scroll' ||
            computedStyle.overflowY === 'auto' || computedStyle.overflowY === 'scroll') {
            return node;
        }

        return this.getScrollableParent(node.parentElement);
    };

    onToggle = (event) => {
        if (event) {
            event.stopPropagation();
        }

        if (this.props.toggle) {
            this.props.toggle();
        }

        let menuPosition = 'bottom';
        const scrollableParent = this.getScrollableParent(this.element);
        if (scrollableParent) {
            const offsetTop = this.element.offsetTop - scrollableParent.offsetTop - scrollableParent.scrollTop;
            const scrollableParentCenter = scrollableParent.clientHeight / 2;
            if (offsetTop > scrollableParentCenter) {
                menuPosition = 'top';
            }
        }
        this.setState({ position: menuPosition, hovered: null });
    };

    handleKeyDown = (event) => {
        const { hovered } = this.state;
        const { open, items } = this.props;

        if (event.keyCode === Key.SPACE || event.keyCode === Key.ENTER) {
            event.stopPropagation();
            event.preventDefault();

            if (open && hovered != null) {
                items[hovered].onClick();
            }
            this.onToggle();
        }

        if (event.keyCode === Key.ESC && open) {
            event.stopPropagation();
            event.preventDefault();

            this.onToggle();
        }

        if (event.keyCode === Key.DOWN || event.keyCode === Key.UP) {
            event.stopPropagation();
            event.preventDefault();

            if (!open) {
                this.setState({ open: true });
            } else {
                if (event.keyCode === Key.DOWN) {
                    this.hoverFirstAvailableItem(hovered != null ? hovered + 1 : 0);
                }
                if (event.keyCode === Key.UP) {
                    this.hoverFirstAvailableItem(hovered != null ? hovered - 1 : items.length - 1, true);
                }
            }
        }
    };

    hoverFirstAvailableItem = (fromIndex, directionUp) => {
        const { items } = this.props;

        const diff = directionUp ? -1 : 1;
        for (let index = fromIndex; directionUp ? index >= 0 : index < items.length; index += diff) {
            if (!items[index].disabled) {
                this.setState({ hovered: index });
                return;
            }
        }
    };

    onHover = (value) => {
        this.setState({ hovered: value });
    };

    onRef = (element) => {
        this.element = element;
    };

    onItemClick = (event, item) => {
        event.stopPropagation();
        item.onClick();
    };

    render() {
        const { className, itemClassName, iconClassName, items, open } = this.props;
        const { hovered } = this.state;

        return <div className={block()} ref={this.onRef}>
            <FuseButton
                active={open}
                icon="more_vert"
                onClick={this.onToggle}
                qa={this.props.qa}
            />
            {open ? <Dropdown onClose={this.onToggle}>
                <div className={cn(block('Menu', { position: this.state.position }), className)}>
                    {items.map((item, itemIndex) => <FuseButton
                        key={'item_' + itemIndex}
                        className={cn(block('MenuItem', { hover: itemIndex === hovered }), itemClassName)}
                        disabled={item.disabled}
                        icon={item.icon}
                        iconClassName={cn(block('MenuItemIcon'), iconClassName)}
                        onMouseEnter={() => this.onHover(itemIndex)}
                        onMouseLeave={() => this.onHover(null)}
                        onClick={(event) => this.onItemClick(event, item)}
                        qa={item.qa}
                        fullWidth
                        noCenter
                    >
                        {item.label}
                    </FuseButton>)}
                </div>
            </Dropdown> : null}
        </div>;
    }
}

export const ObservableFuseMenu = observer(({ store, menuId, ...props }) => <FuseMenu
    open={store.getValue() === menuId}
    toggle={() => store.toggle(menuId)}
    {...props}
/>);

ObservableFuseMenu.propTypes = {
    store: MenuStore.PropType.isRequired,
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ...FuseMenu.propTypes,
};


